import * as React from "react"
const CourseIcon = (props) => (
    <img src="/Icons/course.svg" alt="course" {...props}/>
)
export default CourseIcon